import * as types from '../actions/ActionTypes';

const INITIAL_STATE = {
  organizationTree: { name: 'Loading...', children: [] },
  isLoading: false
};
export function treeReducer(state, action) {
  if (typeof state === 'undefined') {
    return INITIAL_STATE;
  } else {
    switch (action.type) {
      case types.SET_ORG_TREE_FULFILLED: {
        return {
          ...state,
          organizationTree: action.payload
        };
      }
      default:
        return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tree.reducer.js